// extracted by mini-css-extract-plugin
export default {"embeddedHotspot":"_2TFgNjzbwa531GTbuIicCa"};